import React from 'react'
import SvgIcon from '@material-ui/core/SvgIcon/SvgIcon'
import { SvgIconProps } from '@material-ui/core'

/**
 * Figma link: https://www.figma.com/file/3z9SovcAVVWRw6bR0jPFLc/UI_library_2.0?node-id=5835%3A5
 *
 * @param {SvgIconProps} props - svg props
 */
export const MakeCallButtonIcon = (props: SvgIconProps): JSX.Element => {
    const color = props.color || 'currentColor'
    const svgProps = Object.assign({}, props)
    delete svgProps.color
    return (
        <SvgIcon {...svgProps} width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
            <path d='M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z' fill={color}/>
            <path fillRule='evenodd' clipRule='evenodd' d='M9.01111 11.3278C9.81111 12.9 11.1 14.1833 12.6722 14.9889L13.8944 13.7667C14.0444 13.6167 14.2667 13.5667 14.4611 13.6333C15.0833 13.8389 15.7556 13.95 16.4444 13.95C16.75 13.95 17 14.2 17 14.5056V16.4444C17 16.75 16.75 17 16.4444 17C11.2278 17 7 12.7722 7 7.55556C7 7.25 7.25 7 7.55556 7H9.5C9.80556 7 10.0556 7.25 10.0556 7.55556C10.0556 8.25 10.1667 8.91667 10.3722 9.53889C10.4333 9.73333 10.3889 9.95 10.2333 10.1056L9.01111 11.3278Z' fill='white'/>
        </SvgIcon>
    )
}

export default MakeCallButtonIcon
